import React from "react";

const UploadIcon = ({ stroke = "#2D2C44" }) => (<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.3327 16.0003L15.9993 10.667M15.9993 10.667L10.666 16.0003M15.9993 10.667V21.3337M29.3327 16.0003C29.3327 23.3641 23.3631 29.3337 15.9993 29.3337C8.63555 29.3337 2.66602 23.3641 2.66602 16.0003C2.66602 8.63653 8.63555 2.66699 15.9993 2.66699C23.3631 2.66699 29.3327 8.63653 29.3327 16.0003Z" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>);

export default UploadIcon;
